module.exports = __webpack_public_path__ + "media/images/orbit/rotator-black-09ba33e08d57429c9d274b8631095b68e35821f3ce6e58ffb03c70d38afe92f3.png";